import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import Favicon from "react-favicon";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <div>
  <Favicon url="https://res.cloudinary.com/dzzgflvyp/image/upload/v1688496264/LEV/favicon/shape_itusth.ico" />
  <React.StrictMode>
    <App />
  </React.StrictMode>
  </div>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
